import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { NgImageSliderModule } from 'ng-image-slider';
import { ButtonModule } from '../../../../../../../libs/ui/components/button/button.module';
import { StarsRatingModule } from '../../../../../../../libs/ui/components/stars-rating/stars-rating.module';
import { RoomDetailedCardComponent } from './room-detailed-card.component';
import { CurrencyExchangeConverterModule } from 'src/app/libs/common/pipes/currency-exhange-converter/currency-exhange-convertermodule';
import { I18nModule } from 'src/app/core/languages-support/i18n.module';
import { AppSupportedLanguages } from 'src/app/core/languages-support/i18n-config.service';
import { AbsModule } from "../../../../../../../libs/common/pipes/abs/abs.module";

@NgModule({
  declarations: [
    RoomDetailedCardComponent,
  ],
  imports: [
    CommonModule,
    MatCardModule,
    ButtonModule,
    StarsRatingModule,
    NgImageSliderModule,
    I18nModule.forRoot(AppSupportedLanguages),
    MatDividerModule,
    CurrencyExchangeConverterModule,
    AbsModule
],
  exports: [
    RoomDetailedCardComponent,
  ],
})
export class RoomDetailedCardModule { }
